import React, { Fragment } from "react";
import _ from "lodash";
import num from "numeral";
import { connect } from "formik";
import { Grid } from "@material-ui/core";
import { TextInput, MoneyInput } from "components/Global/FormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const SideLabelMoneyWithRefInput = ({ label, fieldName, refFieldName, placeholder, formik, isDisabled, hasBorder, ...otherProps }) => {
  const val = _.get(formik.values, fieldName);
  const refVal = _.get(formik.values, refFieldName || `${fieldName}Ref`);

  return (
    <LateralField label={label} hasBorder={hasBorder}>
      {isDisabled && (
        <Grid container item spacing={16}>
          <Grid item xs={6}>
            <ViewOnlyDiv>{val ? num(val).format("$0,0") : ""}</ViewOnlyDiv>
          </Grid>
          <Grid item xs={6}>
            <ViewOnlyDiv placeholder="No reference">{refVal}</ViewOnlyDiv>
          </Grid>
        </Grid>)}
      {!isDisabled && (
        <Grid container item spacing={16}>
          <Grid item xs={6}>
            <MoneyInput
              fullWidth
              fieldName={fieldName}
              placeholder={placeholder}
              {...otherProps}
            />
          </Grid>
          <Grid item xs={6}>
            <TextInput
              fullWidth
              fieldName={refFieldName || `${fieldName}Ref`}
              placeholder="Add a reference"
              {...otherProps}
            />
          </Grid>
        </Grid>)}
    </LateralField>
  );
};
export default connect(SideLabelMoneyWithRefInput);
